import { SELECIONAR_ORIGEM } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarOrigem (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_ORIGEM: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
